import {lazy, Suspense} from 'react';

import {Page} from '../../../layout/page/page';
import {MainPageContainer} from '../../../layout/page-card/main-page-card';
import {Spinner} from '../../../layout/spinner/spinner';

const WidgetRouter = lazy(() => import('./widget-router'));

export function WidgetIndex(): JSX.Element {
    return (
        <Suspense
            fallback={
                <Page
                    isTopFilterHidden
                    renderContainer={(children) => <MainPageContainer>{children}</MainPageContainer>}
                >
                    <Spinner position="absolute" />
                </Page>
            }
        >
            <WidgetRouter />
        </Suspense>
    );
}
